import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import i18n from "i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as UKanFlag } from "../../assets/images/flags/gb.svg";
import { ReactComponent as JordanFlag } from "../../assets/images/flags/jo.svg";
import { languageType } from "../../common/Utils/ApiConstants";
import { rtlAction } from "../../store/Reducer";
import Translate from "../../translation/utils/translateFunction";
import Loader from "../staff/Owner/LoadingComp";
import { ReactComponent as BrandLogo } from "../../assets/images/FoM_logo.svg";

import Fro1 from "../../assets/images/Illustration_1.svg";
import Fro2 from "../../assets/images/Illustration_2.svg";
import Fro3 from "../../assets/images/Illustration_3.svg";
import { showToast } from "../../common/Utils/ToastMessage";
import { StyledTypography } from "../../common/Utils/StyledComponents";

const ChangeLanguage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLanguageLoading, setIsLanguageLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState();

  const handleChangeLanguage = (lang) => {
    setIsLanguageLoading(true);

    if (lang === languageType.english) {
      dispatch(rtlAction(false));
      localStorage.setItem("isRtl", "false");
      i18n.changeLanguage("en");
    } else if (lang === languageType.arabic) {
      dispatch(rtlAction(true));
      localStorage.setItem("isRtl", "true");
      i18n.changeLanguage("ar");
    }
    navigate("/login");

    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  console.log("selectedLanguage", selectedLanguage, !selectedLanguage);
  return (
    <div className="auth">
      <Loader loading={isLanguageLoading} />

      <div className="auth_left">
        <div className="card" style={{ zIndex: 999 }}>
          <div className="text-center mb-30">
            <Link className="header-brand" to="/">
              <BrandLogo className="forLogo"></BrandLogo>
            </Link>
          </div>

          <div className="card-body">
            <StyledTypography
              variant="subtitle2"
              style={{
                padding: "0px 7px",
                marginTop: "1.3rem",
                marginBottom: "2.5rem",
              }}
            >
              {Translate("common:languagePeference")}
            </StyledTypography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <Box
                onClick={() => setSelectedLanguage(languageType.english)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.5,
                  borderRadius: "8px",
                  backgroundColor: "#eceff4",
                  cursor: "pointer",
                  transition: "0.3s",
                  border:
                    selectedLanguage === languageType.english
                      ? "2px solid #02005B"
                      : "2px solid transparent",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <UKanFlag className="changelanguageFlags" />
                <Typography>English</Typography>
              </Box>

              <Box
                onClick={() => setSelectedLanguage(languageType.arabic)}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  p: 1.5,
                  borderRadius: "8px",
                  backgroundColor: "#eceff4",
                  cursor: "pointer",
                  transition: "0.3s",
                  border:
                    selectedLanguage === languageType.arabic
                      ? "2px solid #02005B"
                      : "2px solid transparent",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <JordanFlag className="changelanguageFlags" />
                <Typography>Arabic</Typography>
              </Box>
            </Box>
            <div className="form-footer">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                onClick={() => {
                  if (selectedLanguage) {
                    handleChangeLanguage(selectedLanguage);
                  } else {
                    showToast({
                      message: Translate("common:languageselect"),
                      type: "error",
                    });
                  }
                }}
              >
                {Translate("common:nextToolTip")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="auth_right">
        <div
          className="carousel slide"
          data-ride="carousel"
          data-interval={3000}
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={Fro1} className="img-fluid" alt="login page" />

              <div className="px-4 mt-4"></div>
            </div>
            <div className="carousel-item">
              <img src={Fro2} className="img-fluid" alt="login page" />
              <div className="px-4 mt-4"></div>
            </div>
            <div className="carousel-item">
              <img src={Fro3} className="img-fluid" alt="login page" />
              <div className="px-4 mt-4"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeLanguage;
